export default function useModalConfirm() {
  return {
    showModalConfirm: (options) => {
      alert(`${options.title}: ${options.content}`);
      options.confirm.action();
    },
    hideModalConfirm: () => {
      console.log('Modal closed');
    },
  };
}